export const setBonusesTutorialToStorage = () => {
  localStorage.setItem('bonusesTutorial', 'shown');
};
